import React, { useState, useEffect } from "react";
import { Row, Col, Input, Checkbox, Tag, Tooltip, Space, Avatar, Button, Menu, Dropdown, Switch } from "antd";
import { FiSearch } from "react-icons/fi";
import { CustomSearchContainer } from "../../../table-item";
import { StyledTable } from "../../admin/videos/styled";
import { EyeOutlined, DeleteOutlined, EditOutlined, LockOutlined, MailOutlined, KeyOutlined, MoreOutlined } from "@ant-design/icons";
import moment from "moment";
import { capitalizeFirstLetter } from "../../../../utils/utils";
import { extractToken } from "../../../../utils/localStorage";
import { ccmManagerService } from "../../../../services/user";
import PhysicianDetailModal from "../../physician_page/component/PhysicianDetailModal";
import { notify } from "../../../../utils/helper";
import { StyledMenu } from "../../physician_page/styled";
import authService from "../../../../services/auth";

const CCMCoordinatorMyManager = ({
  managerData,
  managerDataCount,
  setIsManagerEdit,
  managerId,
  setManagerId,
  setIsCreateManagerModalOpen,
  loading,
  handleManagerSearch,
  setIsDeleteModalOpen,
  pagination,
  setPagination,
  handleChangeTable,
  fetchManager,
}) => {
  const user = extractToken();

  const [selectedManagerIds, setSelectedManagerIds] = useState([]);
  const [managerDataById, setManagerDataById] = useState({});
  const [isDeatilsOpen, setIsDeatilsOpen] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
   const [isMfaEnabled, setIsMfaEnabled] = useState(false);

  const handleManagerCheckbox = (checked, record) => {
    if (checked) {
      setSelectedManagerIds([...selectedManagerIds, record._id]);
      setIsDropdownVisible(true);
    } else {
      const newSelection = selectedManagerIds.filter((id) => id !== record._id);
      setSelectedManagerIds(newSelection);
      setIsDropdownVisible(newSelection.length > 0);
    }
  };

  const get2FATag = (is2FaDisable) => {
    if (is2FaDisable) {
      return <Tag color="red">Disabled</Tag>;
    }
    return <Tag color="green">Enabled</Tag>;
  };

  const managerColumns = [
    {
      title: "Select",
      key: "select",
      width: 60,
      fixed: "left",
      render: (_, record) => (
        <Checkbox
          checked={selectedManagerIds.includes(record._id)}
          onChange={(e) => handleManagerCheckbox(e.target.checked, record)}
        />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "fullName",
      width: 250,
      sorter: (a, b) => (a.fullName || "").localeCompare(b.fullName || ""),
    },
    {
      title: "Physician",
      dataIndex: "parent",
      width: 200,
      key: "parentName",
      sorter: (a, b) => (a.parentName || "").localeCompare(b.parentName || ""),
      render: (parent) => (
        <>
          {parent ? (
            <div className="row-flex">
              <div className="d-flex justify-content-center">
                <Avatar
                  size={40}
                  style={{
                    marginRight: "8px",
                    backgroundColor: "var(--border-color)",
                    color: "var(--primary-text-color)",
                  }}
                >
                  {capitalizeFirstLetter(parent?.name?.[0])}
                </Avatar>
              </div>
              <div className="d-flex flex-column justify-start align-start">
                <span>{capitalizeFirstLetter(parent.name)}</span>
                <span>{capitalizeFirstLetter(parent.email)}</span>
              </div>
            </div>
          ) : (
            <div>{"N/A"}</div>
          )}
        </>
      ),
      hidden: user?.role !== "SuperAdmin",
    },
    {
      title: "2FA Status",
      dataIndex: "is2FaDisable",
      key: "towfaStatus",
      width: 120,
      align: "center",
      render: (is2FaDisable) => get2FATag(is2FaDisable),
    },
    {
      title: "Email Verified",
      dataIndex: "isEmailVerified",
      align: "center",
      key: "isEmailVerifiedText",
      sorter: (a, b) =>
        (a.isEmailVerifiedText || "").localeCompare(
          b.isEmailVerifiedText || ""
        ),
      render: (verified) => (
        <Tag color={verified ? "green" : "orange"}>
          {verified ? "Verified" : "Not Verified"}
        </Tag>
      ),
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      align: "center",
      width: 200,
      key: "createdAt",
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      render: (date) =>
        date ? moment(date).format("DD MMM YYYY hh:mm A") : "N/A",
    },
    {
      title: "Actions",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="View Details">
            <div
              onClick={() => {
                setManagerId(record?._id);
                setIsDeatilsOpen(true);
              }}
              className="icon-button-view"
            >
              <EyeOutlined />
            </div>
          </Tooltip>
          <Tooltip title="Edit">
            <div
              onClick={() => {
                setIsManagerEdit(true);
                setManagerId(record?._id);
                setIsCreateManagerModalOpen(true);
              }}
              className="icon-button-edit"
            >
              <EditOutlined />
            </div>
          </Tooltip>
          <Tooltip title="Delete">
            <div
              onClick={() => {
                setManagerId(record?._id);
                setIsDeleteModalOpen(true);
              }}
              className="icon-button-delete"
            >
              <DeleteOutlined />
            </div>
          </Tooltip>
        </Space>
      ),
    },
  ];

  const getManagerById = async () => {
    try {
      const res = await ccmManagerService.getById(managerId);
      setManagerDataById(res?.data);
      setManagerId("");
    } catch (err) {
      notify("error", err?.data);
    }
  };
  useEffect(() => {
    if (managerId && isDeatilsOpen) {
      getManagerById();
    }
  }, [managerId]);

  const handleAction = async (actionType) => {
    const selectedIds =
      selectedManagerIds.length > 0
        && selectedManagerIds ;
      if (selectedIds.length === 0) return;
    
       try {
        switch (actionType) {
          case "toggleMfa":
            await authService.disableMfaUser({
              userIds: selectedIds,
              is2FaDisable: !isMfaEnabled,
            });
            notify(
              "success",
              isMfaEnabled
                ? "2FA enabled successfully"
                : "2FA disabled successfully"
            );
            if (selectedManagerIds.length > 0) {
              fetchManager();
            }
            break;
          case "resendInvite":
            await authService.resendInviteEmail({ userIds: selectedIds });
            notify("success", "Invite emails sent successfully");
            break;
          case "resetPassword":
            await authService.resetPasswordUsers({ userIds: selectedIds });
            notify("success", "Password reset emails sent successfully");
            break;
        }
        setSelectedManagerIds([]);
      } catch (error) {
        notify("error", "Failed to perform action");
      }
    };

  const actionMenu = (
    <StyledMenu>
      <Menu.Item key="mfa">
        <div className="menu-item-content">
          <LockOutlined className="menu-item-icon" />
          <span className="menu-item-text">2FA Disable</span>
          <Switch
            size="small"
            checked={isMfaEnabled}
            onChange={(checked) => {
              setIsMfaEnabled(checked);
              handleAction("toggleMfa");
            }}
          />
        </div>
      </Menu.Item>
      <Menu.Item
        key="resendInvite"
        onClick={() => handleAction("resendInvite")}
      >
        <div className="menu-item-content">
          <MailOutlined className="menu-item-icon" />
          <span className="menu-item-text">Resend Invite</span>
        </div>
      </Menu.Item>
      <Menu.Item
        key="resetPassword"
        onClick={() => handleAction("resetPassword")}
      >
        <div className="menu-item-content">
          <KeyOutlined className="menu-item-icon" />
          <span className="menu-item-text">Reset Password</span>
        </div>
      </Menu.Item>
    </StyledMenu>
  );

  const handleManagerPagination = (page) => {
    setPagination((prev) => ({ ...prev, current: page }));
  };

  const hasData = managerData.length > 0;
  const scroll = hasData.length ? { y: `calc(100vh - 320px)`, x: true } : null;

  return (
    <>
    {isDeatilsOpen && (
      <PhysicianDetailModal 
        isOpen={isDeatilsOpen}
        setOpen={setIsDeatilsOpen}
        DataById={managerDataById}
        title={"CCM Manager Details"}
        subtitle={"View the details of the CCM Manager"}
      />
    )}
    <Row className="d-flex justify-content-center">
      <Col span={24} style={{ flex: 1, padding: "0px 0px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "16px",
          }}
        >
          <div
            className="d-flex  gap-12"
            style={{ width: "100%", justifyContent: "start" }}
          >
            <CustomSearchContainer>
              <FiSearch
                style={{ position: "absolute", zIndex: 1 }}
                className="icon ml-5"
              />
              <Input
                placeholder="Search Managers..."
                // value={schedulerSearchText}
                onChange={(e) => {
                  handleManagerSearch(e.target.value);
                }}
              />
            </CustomSearchContainer>
            {/* <Filter
                show={show}
                setShow={setShow}
                data={[
                  {
                    title: "Specialty",
                    list: specialtyList,
                    filterList: filterTab,
                    setFilterList: setFilterTab,
                  },
                ]}
              /> 
            */}
          </div>
          <div
            style={{ display: "flex", gap: "8px", alignItems: "center" }}
          >
            {selectedManagerIds.length > 0 && (
              <Dropdown
                getPopupContainer={(triggerNode) =>
                  triggerNode.parentNode
                }
                overlay={actionMenu}
                trigger={["click"]}
                placement="bottomRight"
                open={isDropdownVisible}
                onOpenChange={setIsDropdownVisible}
              >
                <Button
                  className="text-primary"
                  icon={<MoreOutlined className="text-primary" />}
                >
                  Actions ({selectedManagerIds.length})
                </Button>
              </Dropdown>
            )}
          </div>
        </div>
        <StyledTable
          columns={managerColumns.filter((col) => !col.hidden)}
          dataSource={managerData}
          rowKey="id"
          loading={loading}
          scroll={scroll}
          pagination={{
            current: pagination?.current,
            pageSize: pagination?.pageSize,
            showSizeChanger: true,
            pageSizeOptions: [25, 50, 100],
            onShowSizeChange: (current, size) => {
              setPagination((prev) => ({
                ...prev,
                current,
                pageSize: size,
              }));
            },
            total: managerDataCount,
            showTotal: (total, range) =>
              `${range[0]} - ${range[1]} of ${total} managers`,
            showQuickJumper: false,
            showLessItems: true,
            onChange: handleManagerPagination,
            itemRender: (page, type, originalElement) => {
              if (type === "prev") {
                return (
                  <Button
                    type="text"
                    disabled={pagination?.current === 1}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (pagination?.current > 1) {
                        setPagination((prev) => ({
                          ...prev,
                          current: prev.current - 1,
                        }));
                      }
                    }}
                  >
                    Previous
                  </Button>
                );
              }
              if (type === "next") {
                const maxPage = Math.ceil(
                  managerDataCount / pagination?.pageSize
                );
                return (
                  <Button
                    type="text"
                    disabled={pagination?.current === maxPage}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (pagination?.current < maxPage) {
                        setPagination((prev) => ({
                          ...prev,
                          current: prev.current + 1,
                        }));
                      }
                    }}
                  >
                    Next
                  </Button>
                );
              }
              return originalElement;
            },
          }}
          onChange={handleChangeTable}
        />
      </Col>
    </Row>
    </>
  );
};

export default CCMCoordinatorMyManager;
